<template>
  <div class="skeleton-revisions-container">
    <div class="skeleton-revisions-header">
      <v-skeleton-loader
        type="text"
        width="100px"
        class="mr-6"
      />
      <DpplSwitch
        class="skeleton-revisions-chart-switch"
        left="Score"
        right="Date"
      />
    </div>
    <div
      class="skeleton-revisions-table"
    >
      <div class="skeleton-revisions-table-data">
        <v-skeleton-loader
          v-for="(_, i) in Array(6)"
          :key="i + 1 * Math.random()"
          type="text"
          width="20px"
          class="text-item"
        />
      </div>
      <div
        class="skeleton-revisions-grid-container"
      >
        <div id="skeleton-revisions-chart-map">
          <div
            v-for="(_, j) in Array(15)"
            :key="j + 1 * Math.random()"
            class="circle"
            :style="circleStyles[j]"
          />
        </div>
        <div
          v-for="(_, i) in Array(6)"
          :key="i * Math.random()"
          class="skeleton-revisions-row"
        >
          <div class="skeleton-border-line" />
        </div>
      </div>
    </div>
    <div class="skeleton-revisions-row final">
      <v-skeleton-loader
        v-for="(_, k) in Array(11)"
        :key="k + 1 * Math.random()"
        type="text"
        width="20px"
        class="mr-1 text-item"
      />
    </div>
  </div>
</template>

<script>
import DpplSwitch from '@/components/datapeople/DpplSwitch.vue';

export default {
  name: 'RevisionsSkeletonLoader',
  components: {
    DpplSwitch,
  },
  data() {
    return {
      circleStyles: [],
      timer: null,
    };
  },
  mounted() {
    this.generateCircleStyles();

    this.timer = setInterval(() => {
      this.generateCircleStyles();
    }, 2000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    generateCircleStyles() {
      const circleStyles = [];

      for (let i = 0; i < 15; i++) {
        const size = 14 * this.randomIntFromInterval(1, 3);
        const top = 100 * this.randomIntFromInterval(1, 2) * Math.random();
        const left = 100 * this.randomIntFromInterval(1, 6) * Math.random();

        const style = {
          top: `${top}px`,
          left: `${left}px`,
          height: `${size}px`,
          width: `${size}px`,
        };

        circleStyles.push(style);
        this.circleStyles = circleStyles;
      }
    },
    randomIntFromInterval(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/less/mixins';

.skeleton-revisions-container {
  background: @white;
  width: calc(100% - 366px);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 24px;
  border-radius: 10px;
  .shadow()
}

.skeleton-revisions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.skeleton-revisions-table {
  display: flex;
  flex-grow: 1;
  align-items: stretch;
  width: auto;
  height: auto;
}

.skeleton-revisions-table-data {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 25px;
}

.skeleton-revisions-grid-container {
  position: relative;
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-around;
}

#skeleton-revisions-chart-map {
  position: absolute;
  top: 0;
  left: 10px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: -8px;
}

.skeleton-revisions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  width: 100%;
  &.final {
    padding-left: 24px;
    padding-top: 0px;
  }
}

.skeleton-border-line {
  border-bottom: 1px solid @stroke-default;
  width: 100%;
}

.circle {
  animation-name: stretch;
  background-color: @grey-400;
  float: left;
  position: absolute;
  border-radius: 50%;
  animation-duration: 1.25s;
  animation-timing-function: ease-out;
  animation-delay: 0s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-fill-mode: none;
  animation-play-state: running;
}

:deep(.text-item) {
  width: 20px;
  height: 10px;
  background: @grey-400;
}

@keyframes stretch {
  0% { transform: scale(.5); }
  100% { transform: scale(1); }
}

.skeleton-revisions-chart-switch {
  border: 1px solid @stroke-default !important;
  pointer-events: none;
  opacity: 0.4;
  top: 0;
  :deep(.v-btn__content) {
      font-size: 12px;
      font-weight: 500;
      color: @text-darkest;
  }
}

:deep(.skeleton-revisions-table-data) {
  div.v-skeleton-loader__text {
      margin-bottom: 0 !important;
  }
}
</style>
